module.exports = __webpack_public_path__ + "static/img/bm.0fdefae8.svg";